import { render, staticRenderFns } from "./PosterPopup.vue?vue&type=template&id=d8754dd4&scoped=true"
import script from "./PosterPopup.vue?vue&type=script&lang=js"
export * from "./PosterPopup.vue?vue&type=script&lang=js"
import style0 from "./PosterPopup.vue?vue&type=style&index=0&id=d8754dd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8754dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8754dd4')) {
      api.createRecord('d8754dd4', component.options)
    } else {
      api.reload('d8754dd4', component.options)
    }
    module.hot.accept("./PosterPopup.vue?vue&type=template&id=d8754dd4&scoped=true", function () {
      api.rerender('d8754dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/posterManagement/components/PosterPopup.vue"
export default component.exports